module.exports = __webpack_public_path__ + "img/hk_nobo.b09750d9.png";